"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Select = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./Select.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Select components are used for collecting user provided information from a
 * list of options.
 *
 * The Select component is built on top of the native HTML `<select>` element,
 * which means that options should be passed as `<option>` child elements.
 *
 * All DOM attributes are supported, and all props, including `refs`, are passed
 * to the `<select>` element.
 */
const Select = /*#__PURE__*/React.forwardRef((props, ref) => (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)("select", _extends({
  css: css.select,
  ref: ref
}, props)), (0, _pragma.createFelaElement)(_.ChevronDownIcon, {
  css: css.icon,
  size: "small"
})));
exports.Select = Select;
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;
//# sourceMappingURL=Select.js.map